import React from "react";

const Learners = () => (
  <div className="learners">
    <div className="">
      <p>
        <strong>Some Of Our Marvellous Clients</strong>
      </p>
      <div className="images">
        <img
          className="ui tiny image"
          src={require("../../../../../assets/images/teams/logos/abinbev.png")}
          alt="abinbev"
        />
        <img
          className="ui tiny image ogilvy"
          src={require("../../../../../assets/images/teams/logos/ogilvy.png")}
          alt="ogilvy"
        />
        <img
          className="ui small image amazon"
          src={require("../../../../../assets/images/teams/logos/amazon.png")}
          alt="amazon"
        />
        <img
          className="ui tiny image apple"
          src={require("../../../../../assets/images/teams/logos/apple.png")}
          alt="apple"
        />
        <img
          className="ui tiny image google"
          src={require("../../../../../assets/images/teams/logos/google.png")}
          alt="google"
        />
        <img
          className="ui tiny image accenture"
          src={require("../../../../../assets/images/teams/logos/accenture.png")}
          alt="accenture"
        />
        <img
          className="ui tiny image"
          src={require("../../../../../assets/images/teams/logos/hsbc.png")}
          alt="hsbc"
        />
        <img
          className="ui tiny image disney"
          src={require("../../../../../assets/images/teams/logos/disney.png")}
          alt="disney"
        />
      </div>
    </div>
  </div>
);

export default Learners;
